import axios from "axios";
import LocalStorageService from "../storage/localstorageService";

axios.defaults.baseURL = "https://localhost:9000";

// LocalstorageService
const localStorageService = LocalStorageService.getService();

// Add a request interceptor
axios.interceptors.request.use(
  (config) => {
    const token = localStorageService.getAccessToken();
    if (token !== "undefined") {
      config.headers["x-access-token"] = "Bearer "+ token;
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    if (response?.status === 200 && response.data.token) {

      // console.log('response.data.token', response.data)

      if (response.data.refreshToken) {
        localStorageService.setToken({
          access_token: response.data.token,
          refresh_token: response.data.refreshToken,
        });

        // console.log('updated both tokens')
      } else {
        localStorageService.setToken({
          access_token: response.data.token
        });
        // console.log('updated access token')
      }

    }
    return response;
  },

  function (error) {
    const originalRequest = error.config;
    // console.log("originalRequest", originalRequest)
    console.log(error.response.status)
    if (error.response?.status === 401 && originalRequest.url === "/data") {
      return Promise.reject(error);
    }

    if (error.response?.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorageService.getRefreshToken();

      console.log('/refresh-token (client) with: ', refreshToken)

      return axios
        .post("/refresh-token", {
          refreshToken,
        })
        .then((res) => {
          if (res.status === 200) {
            localStorageService.setToken({
              access_token: res.data.token,
              // refresh_token: res.data.token,
            });

            // console.log('refreshing token (FE)\n')
            // console.log('refresh token', refreshToken)
            // console.log('access token', res.data.token)
            axios.defaults.headers["x-access-token"] = "Bearer " + 
              localStorageService.getAccessToken();
            return axios(originalRequest);
          }
        });
    }
    return Promise.reject(error);
  }
);

export default axios;
